<template>
  <div id="home-parent" class="page-container">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image parallax-img"
        style="background-image: url('img/background_0.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Blumen-Twins</h1>
          <div class="text-center">
            <h3></h3>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Herzlich willkommen</h2>
            <h4 class="description">
              Wir - die Blumen-Twins in Frankenberg - helfen Ihnen gerne. Ganz gleich, ob es um die schönen Ereignisse in Ihrem Leben geht, oder ob Sie einen anderen Menschen erfreuen wollen.
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              class="image-container"
              src="img/main_1.jpg"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="description">
              Schmücken Sie Ihr Heim mit unseren Sträussen oder Tischdekorationen aus einer aussergwöhnlich grossen und vielfältigen Auswahl.
            </h4>
            <h4 class="description">
              Für den schönsten Tag des Lebens bieten wir eine umfangreiche Auswahl an Brautsträussen und Blumenschmuck rund um die Hochzeit.
            </h4>
            <h4 class="description">
              Ausserdem passen wir unser Angebot sehr kreativ an die aktuelle Jahreszeit an.
            </h4>
            <h4 class="description">
              Und wenn es um den Abschied von einem lieben Menschen aus Ihrer Nähe geht, wenden Sie sich mit Ihren Dekorationswünschen vertrauensvoll an uns.
            </h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 carousel-container">
            <el-carousel :height="carouselHeight" autoplay>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_1.jpeg" alt="First slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_2.jpeg" alt="Second slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_3.jpeg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_4.jpeg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_5.jpeg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_6.jpeg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block cover-image" src="img/unsere_leistungen_7.jpeg" alt="Third slide" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Rufen Sie uns an - wir freuen uns auf Sie!<br>
              <n-button type="primary" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 06451 / 71 84 88
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@blumen-twins.de
              </n-button>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Unser Team</h2>
            <h4 class="description">
              
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/Unser_Team_1.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/Unser_Team_2.jpg"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-primary"></div>
      </div>
    </div>
    <div class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: !secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_1.jpg" media="(min-width: 600px)" />
            <img src="img/background_1.jpg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Unsere Leistungen</h2>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Dekoration für Hochzeiten (Brautsträuße), Taufen, Konfirmationen und Kommunionen, Firmenveranstaltungen, Geburtstagsfeier<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Trauerfloristik: Kränze, Gestecke, Urnenkränze, Grabsträuße mit Schleifen, Lieferung zur Trauerfeier.<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Individuelle Sträuße & Gestecke: Für Geburtstage, Jubiläen, saisonale Anlässe (Frühling, Herbst, Totensonntagsgestecke, Winter, Adventsgestecke).<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Pflanzen & Beratung: Verkauf und Pflege von Zimmer- und Gartenpflanzen, Beratung zu Schnittblumen<br>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="section section-about-us">
      <div class="container">
        
      </div>
    </div>
    -->
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Hochzeit</h2>
            <h4 class="description">
              Für den schönsten Tag des Lebens bieten wir eine umfangreiche Auswahl an Brautsträussen und Blumenschmuck rund um die Hochzeit.
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/hochzeit_1.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/hochzeit_2.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-10 ml-auto mr-auto text-center">
                <h4 class="description">
                  <n-button type="primary" round @click="openWedding()">
                    <span class="mdi mdi-flower-outline"></span> weitere Bilder >>
                  </n-button>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Beerdigung und Trauerfeier</h2>
            <h4 class="description">
              Und wenn es um den Abschied von einem lieben Menschen aus Ihrer Nähe geht, wenden Sie sich mit Ihren Dekorationswünschen vertrauensvoll an uns.
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/beerdigung_1.jpeg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <!-- First image on the right side, above the article -->
                <img loading="lazy"
                  class="image-container"
                  src="img/beerdigung_2.jpeg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-10 ml-auto mr-auto text-center">
                <h4 class="description">
                  <n-button type="primary" round @click="openFuneral()">
                    <span class="mdi mdi-flower-outline"></span> weitere Bilder >>
                  </n-button>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Individuelle Sträuße und Gestecke</h2>
            <h4 class="description">
              Schmücken Sie Ihr Heim mit unseren Sträussen oder Tischdekorationen aus einer aussergwöhnlich grossen und vielfältigen Auswahl.
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/straus_1.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <!-- First image on the right side, above the article -->
                <img loading="lazy"
                  class="image-container"
                  src="img/straus_2.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-10 ml-auto mr-auto text-center">
                <h4 class="description">
                  <n-button type="primary" round @click="openBouquets()">
                    <span class="mdi mdi-flower-outline"></span> weitere Bilder >>
                  </n-button>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Totensonntag</h2>
            <h4 class="description">
              Für Allerheiligen und Totensonntag bieten wir eine aussergwöhnlich grosse und vielfältige Auswahl.
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/totensonntag_1.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <!-- First image on the right side, above the article -->
                <img loading="lazy"
                  class="image-container"
                  src="img/totensonntag_2.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-10 ml-auto mr-auto text-center">
                <h4 class="description">
                  <n-button type="primary" round @click="openAllSoulsDay()">
                    <span class="mdi mdi-flower-outline"></span> weitere Bilder >>
                  </n-button>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Advent und Weihnachten</h2>
            <h4 class="description">
              Für die Advents- und Weihnachtszeit bieten wir eine aussergwöhnlich grosse und vielfältige Auswahl.
            </h4>
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto">
                <img loading="lazy"
                  class="image-container"
                  src="img/advent_1.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 ml-auto mr-auto">
                <!-- First image on the right side, above the article -->
                <img loading="lazy"
                  class="image-container"
                  src="img/advent_2.jpg"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-10 ml-auto mr-auto text-center">
                <h4 class="description">
                  <n-button type="primary" round @click="openChristmas()">
                    <span class="mdi mdi-flower-outline"></span> weitere Bilder >>
                  </n-button>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div id="second-background" class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_2_wide.jpg" media="(min-width: 600px)" />
            <img src="img/background_2.jpeg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Von der Fußpflege zur Podologie</h2>
            <h4 class="description">
              Fußpflege sorgt für gepflegte Füße, aber Podologie geht weiter:
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Medizinischer Fachberuf mit klar definierten Standards<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Behandlung krankhafter Veränderungen am Fuß<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Enge Zusammenarbeit mit Ärzten
            </h4>
            <h4 class="description">
              <strong>Schöne Füße macht die Fußpflege - gesunde Füße die Podologie.</strong>
            </h4>
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Kontakt</h2>
        <div class="row">
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <span class="mdi mdi-map-marker-outline"></span> Unsere Adresse:<br>
              Blumen-Twins<br>
              Röddenauer Strasse 9a<br>
              35066 Frankenberg - Eder
            </h4>
          </div>
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <iframe src="https://maps.google.com/maps?q=Blumen+Twins+Röddenauer+Strasse+9a+frankenberg&z=16&output=embed"
                allowfullscreen="allowfullscreen" 
                frameborder="0"
                :width="mapWidth"
                :height="mapHeight"
                data-gtm-yt-inspected-11="true" 
                style="border: 0px;">
              </iframe>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 ml-auto mr-auto text-center">
            <h4 class="description">
              Rufen Sie uns an:<br>
              
              <n-button type="primary" class="phone-btn" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 06451 / 71 84 88
              </n-button><br>
              <span class="opening-time">(Mo-Fr: 9:00 - 18:00, Sa: 9:00 - 14:00)</span><br>
            </h4>
            <h4 class="description small-margin-bottom">
              Oder schreiben Sie uns eine E-Mail<br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@blumen-twins.de
              </n-button>
            </h4>
            <h4 class="description">
              <span class="mdi mdi-heart-outline"></span><strong> Wir freuen uns auf Sie! </strong><span class="mdi mdi-heart-outline"></span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';
import Parallax from 'vue-parallaxy'
export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  created() {
    //window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    //window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    const options = {
      rootMargin: "0px",
      scrollMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75, 1.00],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(this.intersectionY > entry.boundingClientRect.y && entry.intersectionRatio >= 0.5) {
          this.secondForeground = true;
        } else if(this.previousRatio > entry.intersectionRatio
            && this.intersectionY < entry.boundingClientRect.y 
            && entry.intersectionRatio <= 0.5) {
          this.secondForeground = false;
        }
        this.intersectionY = entry.boundingClientRect.y
        this.previousRatio = entry.intersectionRatio
      });
    }, options);

    const target = document.querySelector("#background-observer");
    observer.observe(target);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize); 
  },
  data() {
    return {
      secondForeground: false,
      intersectionY: 0,
      previousRatio: 0,
      mapWidth: "600px",
      mapHeight: "400px",
      carouselHeight: "300px",
    };
  },
  methods: {
    onResize() {
      let mapWidth = window.innerWidth - 10
      mapWidth = Math.min(mapWidth, 600)

      const mapHeight = mapWidth / 1.5

      this.mapWidth = mapWidth + 'px'
      this.mapHeight = mapHeight + 'px'

      const carouselContaner = document.getElementsByClassName("carousel-container")[0];
      let carouselWidth = carouselContaner.clientWidth
      carouselWidth = Math.min(carouselWidth, 800)
      this.carouselHeight = (carouselWidth / 1.5) + 'px'
    },
    openPhone: function() {
      window.location = "tel:+496451718488";
    },
    openEmail: function() {
      window.location = "mailto:kontakt@blumen-twins.de";
    },
    openWedding: function() {
      this.$router.push({ name: 'wedding' });
    },
    openFuneral: function() {
      this.$router.push({ name: 'funeral' });
    },
    openBouquets: function() {
      this.$router.push({ name: 'bouquets' });
    },
    openAllSoulsDay: function() {
      this.$router.push({ name: 'all-souls-day' });
    },
    openChristmas: function() {
      this.$router.push({ name: 'christmas' });
    }
  }
};
</script>
<style scoped lang="scss">
#home-parent {
  scroll-behavior: smooth;
}
.background-img-wrapper {
  background-color: #00000060 !important;

  .title {
    color: white !important;
  }
  .description {
    color: white !important;
    font-weight: normal !important;
  }
  .background-container {
    left: 0;
    bottom: 0;
    position: fixed;
    z-index: -2;
    width: 100vw;
    height: 100vh;

    .background-img {
      * {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
.parallax-img {
  z-index: 0 !important;
}
.foreground {
  z-index: -1 !important;
}
.parallax-test {
  position: relative;
}
.list {
  text-align: left;
  margin-left: 100px;
}
.small-margin-bottom {
  margin-bottom: 5px;
}
.phone-btn {
  margin-bottom: 0 !important;
}
.opening-time {
  font-size: small;
}
.link {
  color: white !important;
  text-decoration: underline;
}
.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
iframe {
  width: 100%;
  height: auto;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 4/3;
}
.video {
  width: auto;
  height: 90vh;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 9/16;
}
.title-logo {
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: 80%;
  height: auto;
}

.carousel-container {
  max-width: 800px !important;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
